export default __webpack_public_path__ + "static/media/ic-communityproject.9b5f97dd.svg";